export enum PopTituloAcao {
  Visualizacao = 1,
  Inclusao = 2,
  Edicao = 3
}